function quickView(){
  const quickShopButtons = document.querySelectorAll('.show-product-quickview');
  quickShopButtons.forEach(button => {
    button.addEventListener('click', function () {
      const url = button.getAttribute('href');
      if (url) {
        openQuickView(url);
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', function () {
  quickView();
});